import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../../util/varios";

import { Dimmer } from "../../spinner";
import { TableBody, TableRow, TableCell, InputAdornment } from "@mui/material";
import useTableFijo from "../../useTableFijo";

import axios from "axios";

const TablaDeudaInmueble = (props) => {
  let token = localStorage.getItem("jwtToken");

  let op = require("../../../../src/modulos/datos");

  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const [tipoMoneda, setTipoMoneda] = useState(0);
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [deuda, setDeuda] = useState();
  const [interes, setInteres] = useState();
  const [recargo, setRecargo] = useState();
  const [multa, setMulta] = useState();
  const [totDeuda, setTotDeuda] = useState();
  const [credito, setCredito] = useState(0.0);

  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    {
      id: "anio",
      label: "AÑO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "mes",
      label: "MES",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "mondeu",
      label: "MONTO",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "intmoradeu",
      label: "INTERES MORA",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "recargodeu",
      label: "RECARGOS",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
  ];

  let heightTabla = 320;

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableFijo(records, headCells, filterFn, heightTabla);

  useEffect(() => {
    if (props.tabDeuda) {
      setCredito(props.credito);

      let deu = parseFloat(0.0);
      let inte = parseFloat(0.0);
      let reca = parseFloat(0.0);
      let mul = parseFloat(0.0);
      for (let i = 0; i < props.tabDeuda.length; i++) {
        deu = deu + parseFloat(props.tabDeuda[i].monto);
        inte = inte + parseFloat(props.tabDeuda[i].intereses);
        reca = reca + parseFloat(props.tabDeuda[i].recargo);
        //mul = mul + parseFloat(props.tabDeuda[i].multa);
      }

      setDeuda(formatMoneda(deu.toString().replace(".", ","), ",", ".", 2));
      setInteres(formatMoneda(inte.toString().replace(".", ","), ",", ".", 2));
      setRecargo(formatMoneda(reca.toString().replace(".", ","), ",", ".", 2));
      //setMulta(formatMoneda(mul.toString().replace(".", ","), ",", ".", 2));
      setTotDeuda(
        formatMoneda(
          (deu + inte + reca + mul).toString().replace(".", ","),
          ",",
          ".",
          2,
        ),
      );
      setRecords(props.tabDeuda);
    } else {
      setRecords();
      setCredito("0,00");
    }
  }, [props.tabDeuda]);

  const imprimirDeuda = (reporte) => (event) => {
    event.preventDefault();

    var idinmueble = props.idinmueble;
    reporte = "EdoCtaCorto2Inm";

    window.open(
      op.reportes +
        "/inmueblesurbanos?" +
        "reporte=" +
        reporte +
        "&id=" +
        idinmueble +
        `&TIPODEUDA=${tipoMoneda === 0 ? 1 :0}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const SelectDeudaC = (idinmuebla, fecha, espiritu, uni) => {
    let endpoint = `${op.conexion}/api/inmueble/deudainmueble?idinmueble=${idinmuebla}&fecha=${fecha}&espiritu=${espiritu}&tipounid=${tipoMoneda}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let factor = parseInt(uni) === 0 ? "1.00" : props.factorcambio;
          var deu = [];
          var his = [];
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              console.log(response.data[i].recargodeu);
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: parseFloat(response.data[i].intmoradeu),
                recargo: response.data[i].recargodeu,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                //multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
              });
            }
          }
          if (deu) {
            let deud = parseFloat(0.0);
            let inte = parseFloat(0.0);
            let reca = parseFloat(0.0);
            let mul = parseFloat(0.0);
            for (let i = 0; i < deu.length; i++) {
              deud = deud + parseFloat(deu[i].monto);
              inte = inte + parseFloat(deu[i].intereses);
              reca = reca + parseFloat(deu[i].recargo);
            }

            setDeuda(
              formatMoneda(deud.toString().replace(".", ","), ",", ".", 2),
            );
            setInteres(
              formatMoneda(inte.toString().replace(".", ","), ",", ".", 2),
            );
            setRecargo(
              formatMoneda(reca.toString().replace(".", ","), ",", ".", 2),
            );
            //setMulta(formatMoneda(mul.toString().replace('.', ','), ',', '.', 2));
            setTotDeuda(
              formatMoneda(
                (deud + inte + reca + mul).toString().replace(".", ","),
                ",",
                ".",
                2,
              ),
            );
          }
          setRecords(deu);

          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const renderDeuda = (e) => {
    SelectDeudaC(props.idinmueble, fechaSistema, espiritu, e.target.value);
  };
  return (
    <div className="card">
      <Dimmer active={activate} inverted></Dimmer>
      <div className="card-body" style={{ height: "100%" }}>
        <div className="content">
          <div className="container">
            <div className="row col-md-12 mx-auto" style={{ height: "100%" }}>
              <div className="row mx-auto d-flex justify-content-between">
                <div className="col-md-12 d-flex justify-content-beetwen mb-2">
                  <div className="col-md-4 row">
                    <div class="form-check col">
                      <input
                        class="form-check-input my-auto"
                        onChange={(e) => {
                          setTipoMoneda(0);
                          renderDeuda(e);
                        }}
                        value={0}
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault1"
                        defaultChecked={tipoMoneda === 0}
                      />
                      <label
                        class="my-auto form-check-label"
                        for="flexRadioDefault1"
                      >
                        Monto en Bs.
                      </label>
                    </div>

                    <div class="form-check col">
                      <input
                        class="form-check-input my-auto"
                        onChange={(e) => {
                          setTipoMoneda(1);
                          renderDeuda(e);
                        }}
                        value={1}
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault2"
                        defaultChecked={tipoMoneda === 1}
                      />
                      <label
                        class="my-auto form-check-label"
                        for="flexRadioDefault2"
                      >
                        Monto en U. C.
                      </label>
                    </div>
                  </div>
                  <button
                    style={{ height: "30px" }}
                    onClick={imprimirDeuda("EdoCtaCorto2Inm")}
                    className="btn btn-sm btn-primary ml-auto rounded-circle"
                  >
                    <i className="fas fa-print"></i>{" "}
                  </button>
                </div>
                <div className="col-md-12 row mx-auto px-0">
                  <TblContainer
                    container={{
                      height: 250,
                      width: "100%",
                      overflow: "auto",
                      padding: "2px",
                    }}
                  >
                    <TblHead />

                    <tbody>
                      {records &&
                        records.map((item, index) => (
                          <tr
                            key={item.anio + item.mes}
                            style={{ padding: "0" }}
                          >
                            <td style={{ fontSize: "10px", textAlign: "left" }}>
                              {item.anio}
                            </td>
                            <td style={{ fontSize: "10px", textAlign: "left" }}>
                              {item.mes}
                            </td>
                            <td
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {item.monto == null
                                ? "0,00"
                                : formatMoneda(
                                    item.monto.toString().replace(".", ","),
                                    ",",
                                    ".",
                                    2,
                                  )}
                            </td>
                            <td
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {item.intereses == null
                                ? "0,00"
                                : formatMoneda(
                                    item.intereses.toString().replace(".", ","),
                                    ",",
                                    ".",
                                    2,
                                  )}
                            </td>

                            <td
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {item.recargo == null
                                ? "0,00"
                                : formatMoneda(
                                    item.recargo.toString().replace(".", ","),
                                    ",",
                                    ".",
                                    2,
                                  )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </TblContainer>
                  <div
                    className="col-md-12 border-table mx-auto row px-0"
                    style={{ borderTop: "none" }}
                  >
                    <div className="col-md-8 row mx-auto">
                      <div className="row col-md-8 mx-auto my-auto">
                        <div className="col">
                          <label
                            htmlFor="inputRitm"
                            style={{ fontSize: "16px", fontWeight: "bold" }}
                          >
                            Crédito a Favor:{" "}
                          </label>
                        </div>
                        <div className="col">
                          <label
                            htmlFor="inputRitm"
                            style={{
                              fontSize: "16px",
                              textAlign: "right",
                              fontWeight: "bold",
                            }}
                          >
                            {props.credito !== null
                              ? formatMoneda(
                                  props.credito.toString().replace(".", ","),
                                  ",",
                                  ".",
                                  2,
                                )
                              : "0,00"}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 row">
                      <div class="input-group input-group-sm mb-0 col-md-12">
                        <span
                          class="input-group-text bg-transparent border-0"
                          id="inputGroup-sizing-sm"
                        >
                          Deuda:
                        </span>
                        <input
                          type="text"
                          value={deuda}
                          class="form-control text-right bg-transparent border-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                        />
                      </div>

                      <div class="input-group input-group-sm mb-0 col-md-12">
                        <span
                          class="input-group-text bg-transparent border-0"
                          id="inputGroup-sizing-sm"
                        >
                          Intereses de Mora:
                        </span>
                        <input
                          type="text"
                          value={interes}
                          class="form-control text-right bg-transparent border-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                        />
                      </div>

                      <div class="input-group input-group-sm mb-0 col-md-12">
                        <span
                          class="input-group-text bg-transparent border-0"
                          id="inputGroup-sizing-sm"
                        >
                          Recargo por Mora:
                        </span>
                        <input
                          type="text"
                          value={recargo}
                          class="form-control text-right bg-transparent border-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                        />
                      </div>

                      <div class="input-group input-group-sm mb-0 col-md-12">
                        <span
                          class="input-group-text bg-transparent border-0"
                          id="inputGroup-sizing-sm"
                        >
                          Total de la Deuda:
                        </span>
                        <input
                          type="text"
                          value={totDeuda}
                          class="form-control text-right bg-transparent border-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaDeudaInmueble;
